// Login hardening (2026-09-30): client half of the password-login Turnstile (server: server/lib/loginCaptcha.ts).
// Nothing changes until the server answers captchaRequired:true — before that the body is exactly { email, password }.

/** Public Turnstile site key (ships in every page). Same widget/key as web calling; the env var still overrides. */
export const LOGIN_TURNSTILE_DEFAULT_SITE_KEY = "0x4AAAAAAFImhTbxszE3yF15";

export function loginTurnstileSiteKey(env: Record<string, unknown> = (import.meta as any).env ?? {}): string {
  const v = env.VITE_WEB_CALL_TURNSTILE_SITE_KEY;
  return ((typeof v === "string" && v.trim()) || LOGIN_TURNSTILE_DEFAULT_SITE_KEY).trim();
}

export interface LoginCaptchaState { required: boolean; token: string | null; unavailable: boolean }

export function loginRequestBody(email: string, password: string, c: LoginCaptchaState) {
  if (!c.required) return { email, password };
  if (c.token) return { email, password, turnstileToken: c.token };
  if (c.unavailable) return { email, password, turnstileUnavailable: true as const };
  return { email, password };
}

export function responseRequiresCaptcha(j: unknown): boolean {
  return !!j && typeof j === "object" && (j as { captchaRequired?: unknown }).captchaRequired === true;
}
